/**
 * @format
 */
import supportsHTML5Storage from './supportsHTML5Storage';
import Time from '../components/Time';

const KEY = 'deals.sorting';

export const setDealSortingOrderCache = (sortingValue, options = {}) => {
  if (!supportsHTML5Storage()) {
    return;
  }

  const payload = {
    value: sortingValue,
    expires_on: options.expires_on || Time.add(new Date(), 30, 'day'),
  };
  window.localStorage.removeItem(KEY);
  window.localStorage.setItem(KEY, JSON.stringify(payload));
};

export const getDealSortingOrderCache = () => {
  if (!supportsHTML5Storage()) return null;

  try {
    const cachedValue = JSON.parse(window.localStorage.getItem(KEY));
    if (!cachedValue || new Date(cachedValue.expires_on) < new Date()) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return cachedValue.value;
  } catch {
    return null;
  }
};
